import { Formik } from 'formik'
import { useHistory, useLocation } from 'react-router-dom'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

import { ArticleClient } from 'api/clients/ArticleClient'
import { FormValues, TaxonomyEdit } from './TaxonomyEdit'

interface Article {
  howToUseThis: string[] | null
  id: string
  whyTrustThis: string | null
}

interface Props {
  article: Article
  className?: string
}

const ExpandedQueryParamKey = 'taxonomyEdit'
const ErrorMessage = 'Something went wrong, please try again'
export const ShowSuccessMessageQueryParamKey = 'showSuccessMessage'
const SuccessMessage = 'Successfully updated doc'

export const TaxonomyEditContainer = ({ article: { howToUseThis, id, whyTrustThis }, className }: Props) => {
  const history = useHistory()

  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const showSuccessMessage = searchParams.has(ShowSuccessMessageQueryParamKey)
  const collapsed = !searchParams.has(ExpandedQueryParamKey) && !showSuccessMessage

  const hideSuccessMessage = () => {
    searchParams.delete(ShowSuccessMessageQueryParamKey)
    history.push({ search: searchParams.toString() })
  }

  const toggleExpanded = () => {
    if (searchParams.has(ExpandedQueryParamKey)) {
      searchParams.delete(ExpandedQueryParamKey)
    } else {
      searchParams.set(ExpandedQueryParamKey, 'true')
    }

    history.push({ search: searchParams.toString() })
  }

  const updateArticle = async ({ howToUseThis, whyTrustThis }: FormValues) => {
    const { type } = await ArticleClient.updateArticle(id, {
      how_to_use_this: howToUseThis,
      why_trust_this: whyTrustThis,
    })

    if (type === 'success') {
      showToastMessage(SuccessMessage, 'success')
    } else {
      showToastMessage(ErrorMessage, 'error')
    }
  }

  return (
    <Formik initialValues={{ howToUseThis, whyTrustThis }} onSubmit={updateArticle}>
      {({ handleChange, handleSubmit, setFieldValue, values }) => {
        return (
          <TaxonomyEdit
            collapsed={collapsed}
            className={className}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            onToggleCollapse={toggleExpanded}
            onToggleSuccessMessage={hideSuccessMessage}
            setFieldValue={setFieldValue}
            showSuccessMessage={showSuccessMessage}
            values={values}
          />
        )
      }}
    </Formik>
  )
}
